<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
   import moment from 'moment'

   export default {
      page: {
         title: "Schedule Request Details",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Schedule Request Details",
            items: [
               {
                  text: "Doctors",
                  href: "/doctors",
               },                
               
               {
                  text: "Schedules",
                  active: true,
               },                     
            ],

            video_consultation: [
               { mon: [] },
               { tue: [] },
               { wed: [] },
               { thu: [] },
               { fri: [] },
               { sat: [] },
               { sun: [] },
            ],
            video_consultation_checked: true,
            video: {
               duration: 2,
               fees:250,
               commission: 10,
            },

            home: {
               duration: 2,
               fees:250,
               commission: 10,
            },

            clinic: {
               duration: 2,
               fees:250,
               commission: 10,
            },

            home_consultation: [
               { mon: [] },
               { tue: [] },
               { wed: [] },
               { thu: [] },
               { fri: [] },
               { sat: [] },
               { sun: [] },
            ],
            home_consultation_checked: false,

            clinic_consultation: [
               { mon: [] },
               { tue: [] },
               { wed: [] },
               { thu: [] },
               { fri: [] },
               { sat: [] },
               { sun: [] },

            ],
            clinic_consultation_checked: false,
            

            // start: '',
            // end: '',
            duration:"00:05",
            set_time:'',
            hour:'',
            minutes:'',
            time_name:'',

            clinic_id: 2,
            clinic_name: "Clinic Two",
            duration_id: "",
            end: "12:51",
            start: "23:51",

            type: 'clinic',
            // duration_id: '',
            // clinic_id: 1,
            // clinic_name: "Apollo",
            reserved: 2,
            fee:'',
            durations: [
               { value: '', text: 'Select' },
               { value: 1, text: '01 minutes' },
               { value: 2, text: '02 minutes' },
               { value: 3, text: '03 minutes' },
               { value: 4, text: '04 minutes' },
               { value: 5, text: '05 minutes' },
               { value: 6, text: '06 minutes' },
               { value: 7, text: '07 minutes' },
               { value: 8, text: '08 minutes' },
               { value: 9, text: '09 minutes' },
               { value: 10, text: '10 minutes' },
               { value: 11, text: '11 minutes' },
               { value: 12, text: '12 minutes' },
               { value: 13, text: '13 minutes' },
               { value: 14, text: '14 minutes' },
               { value: 15, text: '15 minutes' },
               { value: 16, text: '16 minutes' },
               { value: 17, text: '17 minutes' },
               { value: 18, text: '18 minutes' },
               { value: 19, text: '19 minutes' },
               { value: 20, text: '20 minutes' },
               { value: 21, text: '21 minutes' },
               { value: 22, text: '22 minutes' },
               { value: 23, text: '23 minutes' },
               { value: 24, text: '24 minutes' },
               { value: 25, text: '25 minutes' },
               { value: 26, text: '26 minutes' },
               { value: 27, text: '27 minutes' },
               { value: 28, text: '28 minutes' },
               { value: 29, text: '29 minutes' },
               { value: 30, text: '30 minutes' },
               { value: 31, text: '31 minutes' },
               { value: 32, text: '32 minutes' },
               { value: 33, text: '33 minutes' },
               { value: 34, text: '34 minutes' },
               { value: 35, text: '35 minutes' },
               { value: 36, text: '36 minutes' },
               { value: 37, text: '37 minutes' },
               { value: 38, text: '38 minutes' },
               { value: 39, text: '39 minutes' },
               { value: 40, text: '40 minutes' },
               { value: 41, text: '41 minutes' },
               { value: 42, text: '42 minutes' },
               { value: 43, text: '43 minutes' },
               { value: 44, text: '44 minutes' },
               { value: 45, text: '45 minutes' },
               { value: 46, text: '46 minutes' },
               { value: 47, text: '47 minutes' },
               { value: 48, text: '48 minutes' },
               { value: 49, text: '49 minutes' },
               { value: 50, text: '50 minutes' },
               { value: 51, text: '51 minutes' },
               { value: 52, text: '52 minutes' },
               { value: 53, text: '53 minutes' },
               { value: 54, text: '54 minutes' },
               { value: 55, text: '55 minutes' },
               { value: 56, text: '56 minutes' },
               { value: 57, text: '57 minutes' },
               { value: 58, text: '58 minutes' },
               { value: 59, text: '59 minutes' },
               { value: 60, text: '1 hour' },
            ],

            clinics: [
               { value: '', text: 'Select' },
               { value: 1, text: 'Clinic One' },
               { value: 2, text: 'Clinic Two' },
               { value: 3, text: 'Clinic Three' },
               { value: 4, text: 'Clinic Four' },
               { value: 5, text: 'Clinic Five' },
            ],
            

            home_location: '',
            home_marker: { position: { lat: null, lng: null } },
            home_center: { lat: null, lng: null },
            home_current_place: null,

            home_mapOptions: {
               disableDefaultUI: true,
            },

            errors: {},
            request: {},

         };
      },

      created() {
      //   this.addSession();
        this.fetchSchedules();

      },
      mounted() {
    
      },

      methods: {
         getToken() {
            if (localStorage.getItem('sigohealth_admin')) {
               var sigohealth_admin =  JSON.parse(localStorage.getItem('sigohealth_admin'));
               if(sigohealth_admin.token) {
                  this.token = sigohealth_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
                  
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 
       
         fetchSchedules() {
            let url = "api/admin/doctors/schedule_request_details?schedule_id=" + this.$route.params.id;         
            this.getToken();
            this.loading = true;
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               console.log(responseData);
               this.request = responseData.schedule_requests;
               this.clinic = responseData.schedule_details;
               if(this.clinic) {
                  this.clinic_consultation_checked = true;
                  this.clinic_durations = this.durations;

                  if(this.clinic.length) {
                     this.setConsultations('clinic');
                  }
               } else {
                  this.clinic = this.consultation;
                  this.clinic_durations = this.active_durations;
               }               

                     
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },
         setConsultations(type) {
            var sessions;

            var consultation = [
               { day: [] },
               { day: [] },
               { day: [] },
               { day: [] },
               { day: [] },
               { day: [] },
               { day: [] },
            ];     

            var schedules = [];

            if(type == 'video') {
               sessions = this.video.sessions;

            } else if(type == 'home') {
               sessions = this.home.sessions;

            } else if(type == 'clinic') {
               sessions = this.clinic;
            }

            sessions.forEach(obj => {

               var session = {};
               session.start = obj.start_time;
               session.end = obj.end_time;
               session.session_id = obj.id;
               session.day = obj.day_id;
               session.duration = obj.duration;
               session.token_type = obj.token_type;
               session.clinic_name = obj.clinic_name;
               session.fee = obj.consultation_fee;

               var set_time = obj.duration;
               var hour = set_time.split(':')[0];
               var minutes = set_time.split(':')[1];
               if(hour!='00'){
                  session.time_name = hour+' Hr '+ minutes +' min ';
               }else{
                  session.time_name =  minutes +' min ';
               }

               var index = parseInt(obj.day_id) - 1;
               consultation[index].day.push(session); 

               var schedule = {};
               schedule.day = obj.day_id;               
               schedule.start = moment.utc('2002-02-02 ' + obj.start_time).format('hh:mm A');
               schedule.end = moment.utc('2002-02-02 ' + obj.end_time).format('hh:mm A');
               schedule.duration = obj.duration;
               schedule.token_type = obj.token_type;
               schedule.clinic_id = obj.clinic_id;
               schedule.consultation_fee = obj.consultation_fee;
               // schedule.clinic_name = obj.clinic_name;
               schedules.push(schedule); 

            });

            if(type == 'video') {
               this.video_consultation = consultation;
               this.video_schedules = schedules;

            } else if(type == 'home') {
               this.home_consultation = consultation;
               this.home_schedules = schedules;

            } else if(type == 'clinic') {
               this.clinic_consultation = consultation;
               this.clinic_schedules = schedules;
            }


         },  
         setTime(){
            this.set_time = this.duration;
            this.hour = this.set_time.split(':')[0];
            this.minutes = this.set_time.split(':')[1];
            this.time_name = this.hour+' Hour '+ this.minutes +' minutes ';
         },
         addSession() {
            let week_day;
            switch(this.day) {
               case 0: 
                  week_day = 'mon';
                  break;
               case 1: 
                  week_day = 'tue';
                  break;
               case 2: 
                  week_day = 'wed';
                  break;
               case 3: 
                  week_day = 'thu';
                  break;
               case 4: 
                  week_day = 'fri';
                  break;
               case 5: 
                  week_day = 'sat';
                  break;
               case 6: 
                  week_day = 'sun';
                  break;
               default:
                  week_day = '';
                  break;
            }
            // alert(this.type);
            // alert(this.duration_id);
            if(this.type == 'video') {
               Object.entries(this.video_consultation).forEach(([key,val]) => {
                  if(key == this.day) {
                     val[week_day].push({start: this.start, end: this.end, duration_id: this.duration_id});
                  }
               });
            } else if(this.type == 'home') {
               Object.entries(this.home_consultation).forEach(([key,val]) => {
                  if(key == this.day) {
                     val[week_day].push({start: this.start, end: this.end, duration_id: this.duration_id});
                  }
               });
            } else if(this.type == 'clinic') {
               Object.entries(this.clinic_consultation).forEach(([key,val]) => {
                  if(key == this.day) {
                     val['mon'].push({start: this.start, end: this.end, duration_id: this.duration_id, clinic_id: this.clinic_id, clinic_name: this.clinic_name, reserved: this.reserved});
                  }
               });
            }
            this.clearSession();
            console.log(this.clinic_consultation);
            this.$refs['session-modal'].hide();
         },

         clearSession() {
            this.start = '';
            this.end = '';
            this.day = null;
            this.type = '';
            this.duration_id = '';
            this.clinic_id = '';
            this.clinic_name = '';
            this.reserved = 3;
         },

         removeSession(obj, index) {
              obj.splice(index, 1);
         }, 

         setClinicName() {
            this.clinic_name = event.target.options[event.target.options.selectedIndex].label;
         },

         //sets the position of marker when dragged
         homeHandleMarkerDrag(e) {
            this.clinic_marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
         },

         //Moves the map view port to marker
         homePanToMarker() {
            this.$refs.homeMapRef.panTo(this.clinic_marker.position);
            this.$refs.homeMapRef.setZoom(18);
         },

         //Moves the marker to click position on the map
         homeHandleMapClick(e) {
            this.home_marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
            console.log(e);
         },     

         homeSetPlace(place) {
            this.home_current_place = place;
            if(this.home_current_place) {
               const marker = {
                  lat: this.home_current_place.geometry.location.lat(),
                  lng: this.home_current_place.geometry.location.lng(),
               };
               this.home_center = marker;
               this.home_marker.position = marker;
               this.home_location = place.formatted_address;
            }
         },
      }
   }
</script>

<style type="text/css">
   .schedules table td {
      padding: 10px;
   }

   .schedules table td .row {
      padding: 0;
   }

</style>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                        <a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end"><i
                                                    class='bx bx-chevrons-left'></i> Back</a>
                        
                     </div>
                  </div>
                  <!----- top button area ends---->                  


                    <!------ Clinic Consultation starts ----------> 
                    <b-card header-class="bg-transparent border-light" class="border border-light schedules clinic-schedules">                         
                        <div class="card-body schedulereq">
                           <table >
										<thead style="font-size: medium;">
											<tr>
												<th>Clinic Name</th>
												<th style="text-align: left;">:</th>
												<td style="text-align: right;">{{request.clinic_name}}</td>
											</tr> 

											<tr>
												<th>Doctor Name</th>
												<th style="text-align: left;">:</th>
												<td style="text-align: right;"><span v-if="request.prefix == 1">Dr.</span><span v-else-if="request.prefix == 2">Mr.</span><span v-else-if="request.prefix == 3">Ms.</span>{{request.doctor_name}}</td>
											</tr> 

										</thead>
									</table>
                        </div>
                        <ul class="reservervation-defs">
                            <li><i class="fas fa-square reserved-color"></i> Both</li>
                            <li><i class="fas fa-square not-reserved-color"></i> Token Vending Machine Only</li>
                        </ul>                     
                        <!-- <div class="row m-0" style="clear:both;" v-if="clinic_consultation_checked"> -->
                        <div class="row m-0" style="clear:both;">
                            <div class="col-md-6 col-lg-7 col-xl-7">
                            <label>Session Timings <span class="text-danger">*</span></label>

                            <div class="table-responsive">
                                        
                                <table class="table table-bordered w-100">

                                    <!---- Monday starts-------->
                                    <tr>                                      
                                        <td scope="row">Mon</td>
                                        <td>
                                        <div class="row m-0">
                                            <div class="col-lg-10">
                                             <div class="input-tag" v-bind:class="{ 'reserved': session.token_type == 1, 'not-reserved': session.token_type == 2 }" v-for="(session, index) in clinic_consultation[0].day" :key="index">
                                                <p>{{ session.start | formatTime }} - {{ session.end | formatTime }}| {{session.time_name}}<span @click="removeSession(clinic_consultation[0].day, index, 'clinic')" class="text-danger"></span></p>
                                             </div>
                                               
                                            </div>
                                            <div class="col-lg-2">                    
                                            </div>
                                        </div>
                                        </td>
                                    </tr>
                                    <!---- Monday ends -------->

                                    <!---- Tuesday starts-------->
                                    <tr>
                                        <td>Tue</td>
                                        <td>
                                        <div class="row m-0">
                                            <div class="col-lg-10">
                                             <div class="input-tag" v-bind:class="{ 'reserved': session.token_type == 1 , 'not-reserved': session.token_type == 2}" v-for="(session, index) in clinic_consultation[1].day" :key="index">
                                                <p>{{ session.start | formatTime }} - {{ session.end | formatTime }}| {{session.time_name}}<span @click="removeSession(clinic_consultation[1].day, index, 'clinic')" class="text-danger"></span></p>
                                             </div>
                                               
                                            </div>
                                            <div class="col-lg-2">                    
                                            </div>
                                        </div>
                                        </td>
                                    </tr>
                                    <!---- Tuesday ends-------->

                                    <!---- Wednesday starts-------->
                                    <tr>
                                        <td>Wed</td>
                                        <td>
                                        <div class="row m-0">
                                            <div class="col-lg-10">
                                             <div class="input-tag" v-bind:class="{ 'reserved': session.token_type == 1 , 'not-reserved': session.token_type == 2}" v-for="(session, index) in clinic_consultation[2].day" :key="index">
                                                <p>{{ session.start | formatTime }} - {{ session.end | formatTime }}| {{session.time_name}}<span @click="removeSession(clinic_consultation[2].day, index, 'clinic')" class="text-danger"></span></p>
                                             </div>
                                            </div>
                                            <div class="col-lg-2">                    
                                            </div>
                                        </div>
                                        </td>
                                    </tr>
                                    <!---- Wednesday starts-------->

                                    <!---- Thursday starts-------->
                                    <tr>
                                        <td>Thu</td>
                                        <td>
                                        <div class="row m-0">
                                            <div class="col-lg-10">
                                             <div class="input-tag"  v-bind:class="{ 'reserved': session.token_type == 1 , 'not-reserved': session.token_type == 2}" v-for="(session, index) in clinic_consultation[3].day" :key="index">
                                                <p>{{ session.start | formatTime }} - {{ session.end | formatTime }}| {{session.time_name}}<span @click="removeSession(clinic_consultation[3].day, index, 'clinic')" class="text-danger"></span></p>
                                             </div>

                                               
                                            </div>
                                            <div class="col-lg-2">                    
                                            </div>
                                        </div>
                                        </td>
                                    </tr>
                                    <!---- Thursday starts-------->

                                    <!---- Friday starts-------->
                                    <tr>
                                        <td>Fri</td>
                                        <td>
                                        <div class="row m-0">
                                            <div class="col-lg-10">
                                             <div class="input-tag" v-bind:class="{ 'reserved': session.token_type == 1 , 'not-reserved': session.token_type == 2}" v-for="(session, index) in clinic_consultation[4].day" :key="index">
                                                <p>{{ session.start | formatTime }} - {{ session.end | formatTime }}| {{session.time_name}}<span @click="removeSession(clinic_consultation[4].day, index, 'clinic')" class="text-danger"></span></p>
                                             </div>
                                            </div>
                                            <div class="col-lg-2">                    
                                            </div>
                                        </div>
                                        </td>
                                    </tr>
                                    <!---- Friday starts-------->

                                    <!---- Saturday starts-------->
                                    <tr>
                                        <td>Sat</td>
                                        <td>
                                        <div class="row m-0">
                                            <div class="col-lg-10">
                                             <div class="input-tag"  v-bind:class="{ 'reserved': session.token_type == 1 , 'not-reserved': session.token_type == 2}" v-for="(session, index) in clinic_consultation[5].day" :key="index">
                                                <p>{{ session.start | formatTime }} - {{ session.end | formatTime }}| {{session.time_name}}<span @click="removeSession(clinic_consultation[5].day, index, 'clinic')" class="text-danger"></span></p>
                                             </div>
                                            </div>
                                            <div class="col-lg-2">                    
                                            </div>
                                        </div>
                                        </td>
                                    </tr>
                                    <!---- Saturday ends-------->

                                    <!---- Sunday starts-------->
                                    <tr>
                                        <td>Sun</td>
                                        <td>
                                        <div class="row m-0">
                                            <div class="col-lg-10">
                                             <div class="input-tag" v-bind:class="{ 'reserved': session.token_type == 1, 'not-reserved': session.token_type == 2 }" v-for="(session, index) in clinic_consultation[6].day" :key="index">
                                                <p>{{ session.start | formatTime }} - {{ session.end | formatTime }}| {{session.time_name}}<span @click="removeSession(clinic_consultation[6].day, index, 'clinic')" class="text-danger"></span></p>
                                             </div>
                                            </div>
                                            <div class="col-lg-2">                    
                                            </div>
                                        </div>
                                        </td>
                                    </tr>
                                    <!---- Sunday ends-------->

                                </table>
                            </div>
                            </div>
                            <div class="col-md-6 col-lg-5 col-xl-5 consultation-details">
                           
                            </div>

                        </div>
                            
                    </b-card>
                    <!------ Clinic Consultation ends ---------->

               </div>
            </div>
         </div>
      </div>

         

   </Layout>
</template>
